import React from 'react'
import * as  C from "../componentsM/index"

const IndividualsAndSocieties = () => {
    return (
        <>

            <C.Hero title={"GROUP 2: LANGUAGE ACQUISITION"}
                image={"/hero/12.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>
                    <p>The Group 3 subjects allow students to develop an appreciation of their own culture as well as that of societies different from their own. All courses examine human behaviour and experience and the diversity of the social and cultural environs that shape these factors.</p>


                    <p>Subjects currently offered:</p>

                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>Business and Management (SL & HL):</h1>

                    <p>The programme addresses the rationale behind the formation of business organisations and the principles, practices and basic skills employed to render them successful.</p>


                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>Economics (SL & HL):</h1>

                    <p>Economics is basically a study of resource allocation, scarcity and the methods/processes employed for the satisfaction of human wants.</p>



                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>Global Politics (SL & HL):</h1>


                    <p>This course brings a global perspective to the age old political concepts of power, equality, sustainability and peace. It addresses the need of today’s students to deal with these concepts in the context of the “global village”.</p>



                </div>
            </section>

        </>

    )
}

export default IndividualsAndSocieties